import { REQUEST__STARTED, REQUEST__FINISHED, EXIT__OVERLAY__REQUESTED } from '../constants/actionTypes';

export default function request(state = {
  sendingRequest: false,
  inProgress: [],
  overlay: false
}, action) {

  switch (action.type) {

    case REQUEST__STARTED: {
      return Object.assign({}, state, {
        sendingRequest: true,
        inProgress: state.inProgress.concat([action.payload.requestFrom]),
        overlay: action.payload.overlay
      });
    }

    case REQUEST__FINISHED: {

      let stillInProgress = state.inProgress.filter((item) => item !== action.payload.requestFrom);

      return Object.assign({}, state, {
        sendingRequest: stillInProgress.length > 0,
        inProgress: stillInProgress,
        overlay: action.payload.overlay
      });
    }

    case EXIT__OVERLAY__REQUESTED:{

      return {
        ...state,
        overlay: false
      };
    }

    default: {
      return state;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/requestReducer.js
 **/